import { Paperclip } from 'lucide-react';

const FileUploadArea = ({ onFileUpload }) => {
  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files || []);
    files.forEach(file => onFileUpload(file));
    e.target.value = ''; // Reset input
  };

  return (
    <div>
      <input
        type="file"
        id="file-input"
        onChange={handleFileSelect}
        className="hidden"
        multiple
      />
      <button 
        onClick={() => document.getElementById('file-input').click()}
        className="p-1 hover:bg-neutral-600 rounded-md"
      >
        <Paperclip className="text-gray-500 hover:text-gray-300" size={20} />
      </button>
    </div>
  );
};

export default FileUploadArea;